import { Link } from "react-router-dom";
import { ArrowUpRight, Camera } from "lucide-react";
import { brl, catLabel, img } from "@/lib/api";

export const PhotographerCard = ({ p, index = 0 }) => (
  <Link to={`/fotografos/${p.id}`} data-testid={`photographer-card-${p.id}`}
    className={`group relative block overflow-hidden rounded-[1.75rem] border border-white/10 bg-ink-2 ${index % 2 ? "lg:mt-16" : ""}`}>
    <div className="relative aspect-[4/5] overflow-hidden">
      {p.has_avatar ? (
        <img src={img("avatar", p.id)} alt={p.name} loading="lazy" className="h-full w-full object-cover grayscale transition-[filter,transform] duration-[1.2s] group-hover:scale-105 group-hover:grayscale-0" />
      ) : (
        <div className="grid h-full place-items-center bg-ink-3"><Camera className="h-10 w-10 text-haze" /></div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent" />
      <div className="absolute inset-3 vf-corners opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
    </div>
    <div className="absolute inset-x-0 bottom-0 p-6">
      <div className="flex flex-wrap gap-1.5">
        {(p.specialties || []).map((s) => (
          <span key={s} className="rounded-full border border-white/20 bg-ink/60 px-2.5 py-0.5 font-mono text-[11px] uppercase backdrop-blur">{catLabel(s)}</span>
        ))}
      </div>
      <div className="mt-3 flex items-end justify-between gap-3">
        <div>
          <h3 className="font-display text-2xl font-bold">{p.name}</h3>
          <p className="text-sm text-haze">{p.city || "Fotógrafo associado"}{p.booking_fee_cents > 0 ? ` · reserva ${brl(p.booking_fee_cents)}` : ""}</p>
        </div>
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-flash text-ink transition-transform duration-500 group-hover:rotate-45">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </div>
  </Link>
);
